var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.60156 3.5625L2.43799 13.4799H8.79488L9.71495 3.5625M5.61644 4.63688V11.9923M3.609 4.63688L3.85993 8.31457L4.11086 11.9923M7.62387 4.63688L7.37294 8.31457L7.12201 11.9923","stroke":"#666666","strokeWidth":"0.5","key":0}),React.createElement("rect",{"x":"0.847656","y":"2.32422","width":"9.62083","height":"0.987603","rx":"0.493802","stroke":"#666666","strokeWidth":"0.5","key":1}),React.createElement("path",{"d":"M4.27344 2.07438V1H6.95002V2.07438","stroke":"#666666","strokeWidth":"0.5","key":2})]);
}

Trash.defaultProps = {"width":"11","height":"14","viewBox":"0 0 11 14","fill":"none"};

module.exports = Trash;

Trash.default = Trash;
